import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mobile-page-shell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-page-shell.component.html',
  styleUrls: ['./mobile-page-shell.component.css']
})
export class MobilePageShellComponent {
  @Input() hideBottomNav = false;
}
